// extracted by mini-css-extract-plugin
export var container = "_t2-0";
export var table = "_t2-2";
export var tableWrapper = "_t2-1";